// extracted by mini-css-extract-plugin
export var errorIcon = "_p4-1";
export var nameLogo = "_p4-0";